<template>
  <div class="card" style="margin-bottom: 10px">
    <div class="card-body">
      <div class="row">
        <div class="col-8 col-sm-8 col-md-9 col-lg-9 col-xl-9">
          <p style="margin: 10px; font-weight: bold">
            <i style="margin-right: 10px" class="fas fa-list"></i> LISTADO DE
            TODOS LOS LEADS DE SALUDSA
          </p>
        </div>

        <div
          class="col-2 col-sm-2 col-md-1 col-lg-1 col-xl-1"
          align="center"
          style="display: flex"
        >
          <Skeletor
            v-if="loading"
            :shimmer="true"
            height="20"
            width="100%"
            style="margin: auto"
          />
          <div v-else @click="refresh">
            <i
              style="cursor: pointer; margin: auto"
              class="fas fa-sync text-sm opacity-10"
            ></i>
          </div>
        </div>

        <div
          class="col-2 col-sm-2 col-md-2 col-lg-2 col-xl-2"
          align="right"
          style="display: flex; align-items: center"
        >
          <button
            v-if="!loading && !notAllow"
            @click="downloadExcel"
            class="btn btn-success btn-sm"
            :disabled="downloadingExcel"
            style="margin-left: auto"
          >
            <i v-if="!downloadingExcel" class="fas fa-file-excel me-1"></i>
            <span
              v-if="downloadingExcel"
              class="spinner-border spinner-border-sm me-1"
              role="status"
              aria-hidden="true"
            ></span>
            {{ downloadingExcel ? "Descargando..." : "Descargar Excel" }}
          </button>
        </div>
      </div>

      <div
        v-if="loading"
        class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12"
        style="padding: 0px"
      >
        <div class="row">
          <div class="col-6 col-sm-6 col-md-6 col-lg-6 col-xl-6">
            <Skeletor :shimmer="true" height="40" width="50%" />
          </div>

          <div class="col-6 col-sm-6 col-md-6 col-lg-6 col-xl-6">
            <Skeletor
              :shimmer="true"
              height="10"
              pill
              width="30%"
              style="margin-bottom: 10px"
            />
            <Skeletor :shimmer="true" height="40" width="100%" />
          </div>
          <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
            <table class="table tablesorter">
              <thead class="thead-light">
                <tr>
                  <th><Skeletor :shimmer="true" height="10" width="100%" /></th>
                  <th><Skeletor :shimmer="true" height="10" width="100%" /></th>
                  <th><Skeletor :shimmer="true" height="10" width="100%" /></th>
                  <th><Skeletor :shimmer="true" height="10" width="100%" /></th>
                  <th><Skeletor :shimmer="true" height="10" width="100%" /></th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td><Skeletor :shimmer="true" height="20" width="100%" /></td>
                  <td><Skeletor :shimmer="true" height="20" width="100%" /></td>
                  <td><Skeletor :shimmer="true" height="20" width="100%" /></td>
                  <td><Skeletor :shimmer="true" height="20" width="100%" /></td>
                  <td><Skeletor :shimmer="true" height="20" width="100%" /></td>
                </tr>
                <tr>
                  <td><Skeletor :shimmer="true" height="20" width="100%" /></td>
                  <td><Skeletor :shimmer="true" height="20" width="100%" /></td>
                  <td><Skeletor :shimmer="true" height="20" width="100%" /></td>
                  <td><Skeletor :shimmer="true" height="20" width="100%" /></td>
                  <td><Skeletor :shimmer="true" height="20" width="100%" /></td>
                </tr>
                <tr>
                  <td><Skeletor :shimmer="true" height="20" width="100%" /></td>
                  <td><Skeletor :shimmer="true" height="20" width="100%" /></td>
                  <td><Skeletor :shimmer="true" height="20" width="100%" /></td>
                  <td><Skeletor :shimmer="true" height="20" width="100%" /></td>
                  <td><Skeletor :shimmer="true" height="20" width="100%" /></td>
                </tr>
              </tbody>
            </table>
          </div>

          <div class="col-6 col-sm-6 col-md-8 col-lg-8 col-xl-8">
            <Skeletor :shimmer="true" height="10" pill width="80%" />
          </div>

          <div class="col-6 col-sm-6 col-md-4 col-lg-4 col-xl-4">
            <div class="row">
              <div class="col-4 col-sm-4 col-md-4 col-lg-4 col-xl-4">
                <Skeletor :shimmer="true" height="10" width="100%" />
              </div>

              <div
                class="col-4 col-sm-4 col-md-4 col-lg-4 col-xl-4"
                align="center"
              >
                <Skeletor :shimmer="true" circle size="30" />
              </div>

              <div class="col-4 col-sm-4 col-md-4 col-lg-4 col-xl-4">
                <Skeletor :shimmer="true" height="10" width="100%" />
              </div>
            </div>
          </div>
        </div>
      </div>

      <div v-else-if="notAllow" class="row">
        <div
          class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12"
          align="center"
        >
          <img style="width: 100px" src="/img/caution.svg" />

          <p style="margin-top: 10px; font-size: 14px">
            Tu rol no te permite utilizar la siguiente funcionalidad.
          </p>
        </div>
      </div>

      <DataTable
        v-else
        :columns="columns"
        :options="options"
        :data="leads"
        class="table tablesorter"
        width="100%"
      >
        <thead>
          <tr>
            <th>Fecha/Hora</th>
            <th>ID Venta</th>
            <th data-priority="2">Referidor</th>
            <th data-priority="1">Nombre Completo</th>
            <th>Celular</th>
            <th>Email</th>
            <th data-priority="3">Estado</th>
          </tr>
        </thead>
      </DataTable>
    </div>
  </div>
</template>

<script>
/* eslint-disable */

import DataTable from "datatables.net-vue3";
import DataTablesCore from "datatables.net-bs5";
import "datatables.net-responsive";
import $ from "jquery";

DataTable.use(DataTablesCore);

export default {
  components: {
    DataTable,
  },
  props: ["tokenAuth"],
  data() {
    let role = localStorage.getItem("session");

    return {
      loading: true,
      downloadingExcel: false,
      leads: [],
      notAllow: false,
      role: role,
      columns: [
        { data: "dateFormatted" },
        { data: "contactId" },
        { data: "referrer" },
        {
          data: null,
          render: function (data, type, row, meta) {
            return `${data.firstname + " " + (data.lastname ?? "")}`;
          },
        },
        { data: "phone" },
        { data: "email" },
        {
          data: null,
          render: function (data, type, row, meta) {
            // if (data.dealstage && data.dealstage !== "") {
            //   return data.dealstage;
            // } else {
            //   return data.hs_lead_status;
            // }
            let value = data.dealstage ?? data.hs_lead_status;

            if (value) {
              const statusMap = {
                NEW: "Nuevo",
                BAD_TIMING: "Llamar más tarde",
                QUALIFICADO: "Calificado",
                UNQUALIFIED: "Descalificado",
              };

              // Check if the value exists in the map and return the translation
              value = statusMap[value] ?? value;
              value = value.toLowerCase();
              value = value.charAt(0).toUpperCase() + value.slice(1);
            }

            return value;
          },
        },
      ],
      options: {
        responsive: true,
        ordering: false,
        columnDefs: [
          { responsivePriority: 1, targets: 0 },
          { responsivePriority: 2, targets: -1 },
        ],
        lengthMenu: [
          [7, 15, 25, 35, 50, -1],
          [7, 15, 25, 35, 50, "All"],
        ],
        pageLength: 7,
        language: {
          search: "Buscar:",
          sInfo:
            "Mostrando registros del _START_ al _END_ de un total de _TOTAL_ registros",
          sInfoEmpty:
            "Mostrando registros del 0 al 0 de un total de 0 registros",
          searchPlaceholder: "Ingrese algún dato",
          zeroRecords: "Lo sentimos, no se encontraron resultados",
          processing: "Buscando. Espere por favor...",
          sLengthMenu: "Mostrar _MENU_ registros",
          oPaginate: {
            sFirst: "Primero",
            sLast: "Último",
            sNext: "Siguiente",
            sPrevious: "Anterior",
          },
        },
      },
    };
  },
  computed: {},
  watch: {},
  mounted() {
    this.getLeads();
  },
  methods: {
    refresh() {
      $(document).off("click", ".consultar");
      this.$eventBus.emit("reiniciarListadoVentasAdmin");
    },

    getLeads() {
      this.$https
        .post("/leads/getAllLeads", {
          tokenAuth: this.tokenAuth,
          role: this.role,
        })
        .then((response) => {
          if (response.data.code == 200) {
            this.loading = false;
            this.leads = response.data.leads;
          } else {
            this.loading = true;
            if (response.data.code == 401) {
              localStorage.removeItem("userData");
              this.$store.state.user = "";

              this.$router.push({ name: "Signin" });
            }
          }
        })
        .catch((error) => {
          this.getLeads();
        });
    },

    downloadExcel() {
      this.downloadingExcel = true;
      this.$https
        .post(
          "/leads/exportAllLeadsExcel",
          {
            tokenAuth: this.tokenAuth,
            role: this.role,
          },
          {
            responseType: "blob",
          },
        )
        .then((response) => {
          if (response.data.type === "application/json") {
            const reader = new FileReader();
            reader.onload = () => {
              try {
                const errorData = JSON.parse(reader.result);
                alert(
                  errorData.error ||
                    "Error al descargar el archivo Excel. Por favor, intente nuevamente.",
                );
              } catch (e) {
                alert(
                  "Error al descargar el archivo Excel. Por favor, intente nuevamente.",
                );
              }
              this.downloadingExcel = false;
            };
            reader.readAsText(response.data);
            return;
          }

          const blob = new Blob([response.data], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
          });

          const url = window.URL.createObjectURL(blob);
          const link = document.createElement("a");
          link.href = url;

          const contentDisposition = response.headers["content-disposition"];
          let fileName = "todos_los_leads.xlsx";
          if (contentDisposition) {
            const fileNameMatch = contentDisposition.match(/filename="(.+)"/);
            if (fileNameMatch) {
              fileName = fileNameMatch[1];
            }
          }

          link.setAttribute("download", fileName);
          document.body.appendChild(link);
          link.click();
          link.remove();
          window.URL.revokeObjectURL(url);
          this.downloadingExcel = false;
        })
        .catch((error) => {
          console.error("Error al descargar Excel:", error);
          this.downloadingExcel = false;
          alert(
            "Error al descargar el archivo Excel. Por favor, intente nuevamente.",
          );
        });
    },
  },
};
</script>

<style lang="scss">
@import "datatables.net-dt";
@import "datatables.net-responsive-dt";
</style>
